// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8c528f5f","453":"8d51470f"}[chunkId] + ".chunk.js";
};